import React, { useEffect, useState,useRef } from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import useTheme from "@material-ui/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Button from '@material-ui/core/Button';
import { ConfirmDialog, MaterialTable, PageHeader } from "../../components";
import api from "../../common/api";
import Icon from "@material-ui/core/Icon";
import NewDailyEntry from './components/dailyEntry';
import NewBulkDailyEntry from './components/bulkDailyEntry';
import Mobile from "./components/mobile";
import moment from "moment";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useGlobalState } from '../../state';
import {version, FarmType} from '../../common/enums';
import { isToday } from '../../common/date';
import { standardPageSizes } from '../../common/enums';
import { updateOnboardingTaskStatus } from '../../common/functions';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

import ImageToStruct from './components/ImageToStruct';
const useStyles = makeStyles(theme => ({
    root: {},
    content: props => ({
        // margin: props.isDesktop ? theme.spacing(4) : theme.spacing(1),
    }),
    topBar: {
        marginBottom: theme.spacing(2)
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    red: {
        color: 'red'
    },
    green: {
        color: 'green'
    },
    gridMargin: {
        margin: theme.spacing(1.5)
    },
    formControl: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        minWidth: 160,
    },
    searchButton: {
        color: 'white',
        width: theme.spacing(21.25),
        backgroundColor: '#EF5350',
        '&:hover': {
            backgroundColor: '#E53935',
        },
        margin: theme.spacing(1),
        padding: theme.spacing(1),
        marginLeft: theme.spacing(1.6),
        marginBottom: theme.spacing(4)
    },
    success: {
        color: 'white',
        backgroundColor: '#4CAF50',
        '&:hover': {
            backgroundColor: '#388E3C',
        },
        width: theme.spacing(13.75),
        margin: theme.spacing(1),
        padding: theme.spacing(1),
        marginLeft: theme.spacing(1.6),
        marginBottom: theme.spacing(4)
    },
    addButtonContainer: props => ({
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        flexDirection: props.isSmallScreen ? 'column' : 'row',
    }),
    buttonMarginRight: props => ({
        marginRight: props.isSmallScreen ? theme.spacing(0) : theme.spacing(1)
    }),
    marginTopCustom: props => ({
        marginTop: props.isSmallScreen ? theme.spacing(1) : theme.spacing(0)
    })
}));

let currentData = undefined;
let editMode = false;
// Plain div, not Paper: App.css strips Paper padding on mobile
const entryBoxStyle = { background: 'white', border: '1px solid #e9e5e1', borderRadius: 10, padding: '12px 16px', flex: '0 0 auto' };
const normalizeBroilerEntry = entry => ({
    ...entry,
    closingFeed: entry?.closingFeed ?? 0
});

const DailyEntries = ({ showError, showMessage, match }) => {
    const farmID = match.params['farmID'];
    const [{user}, dispatch] = useGlobalState();
    const farmType = user?.farmData?.find(farm => farm.id === parseInt(farmID))?.farmType || 0;
    const [sheds, setSheds] = useState([]);
    const [materialLists, setMaterialList] = useState([]);
    const [minClosingFeed, setMinClosingFeed] = useState({});

    const [loading, setLoading] = useState(false);

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('xs'), {
        defaultMatches: true
    });
    const classes = useStyles({ isDesktop, isSmallScreen });
    const [dailyEntries, setDailyEntries] = useState([]);
    const [showDailyEntryDialog, setShowDailyEntryDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState('')
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [filterSelectedStartDate, setFilterSelectedStartDate] = useState(null);
    const [filterSelectedEndDate, setFilterSelectedEndDate] = useState(null);
    const [ShowBulkAddDialog, setShowBulkAddDialog] = useState(false);
    const [availableMedicineStock,setAvailableMedcineStock] = useState([])
    // feed materials for the purchases section (Pro + auto_purchase only)
    const [feedMaterials, setFeedMaterials] = useState([]);
    const showPurchases = user?.versionID === version.pro && !!user?.Config?.auto_purchase;
    const [ pageSize, setPageSize] = useState(5)
    const rowsPerPageArray = useRef();
    const [builkEntriesData, setBuilkEntriesData] = useState([]);

    const handleDailyEntryClose = () => {
        setMinClosingFeed({})
        setErrorMessage('');
        currentData = undefined;
        setShowDailyEntryDialog(false);
    };
    const handleImageParseError = (message) =>{
        showError(message);
        setLoading(false);
    }


const generateDailyEntryLandscapePDF = () => {
  const doc = new jsPDF({ orientation: "landscape" });
  const farmName = window.localStorage.getItem("farmName") || "N/A";
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const dateLabel = "Date: ___________";
  const textWidth = doc.getTextWidth(dateLabel);

  const drawHeader = () => {
    doc.setFontSize(14);
    doc.text(`Daily Entry Sheet for Farm: ${farmName}`, 10, 15);
    doc.text(dateLabel, pageWidth - textWidth - 14, 15);
    doc.text(`Farm ID: ${farmID}`, 10, 23);
    doc.setFontSize(10);
  };

  const drawFooter = (pageNumber, totalPages) => {
    doc.setFontSize(9);
    doc.text(
      `Page ${pageNumber} of ${totalPages}`,
      pageWidth / 2,
      pageHeight - 10,
      { align: "center" }
    );
  };

  const getEggTypes = () =>
    materialLists
      .filter((mat) => mat.id > 0)
      .map((mat) => ({
        name: mat.name.toUpperCase().replace(" EGGS", ""),
        id: mat.id,
      }));

  let headers;
  if (user.versionID === version.lite) {
    headers = [[
      "Shed", "Shed ID", "Mortality (Nos)", "Egg Type (Enter ID)",
      "Egg Sales (Trays)", "Closing Stock (Trays)", "Broken Egg (Nos)",
      "Damaged (Nos)", "Closing Feed (Kg)", "Feed Received (Kg)"
    ]];
  } else if (user.versionID === version.pro) {
    headers = [[
      "Shed", "Shed ID", "Mortality (Nos)", "Egg Type (Enter ID)",
      "Egg Sales (Trays)", "Closing Stock (Trays)", "Broken Egg (Nos)",
      "Damaged (Nos)", "Closing Feed (Kg)", "Feed Received (Kg)",
      "Feed Cost (per unit)"
    ]];
  } else {
    headers = [[
      "Shed", "Shed ID", "Mortality (Nos)", "Egg Type (Enter ID)",
      "Egg Sales (Trays)", "Closing Stock (Trays)", "Broken Egg (Nos)",
      "Damaged (Nos)", "Closing Feed (Kg)"
    ]];
  }

  const rows = sheds
    .filter((shed) => shed.isActive)
    .map((shed) => [
      shed.name,
      shed.id,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ]);

  const eggTypes = getEggTypes();

  // Main Table
  doc.autoTable({
    head: headers,
    body: rows,
    theme: "grid",
    styles: { fontSize: 8, halign: "center", cellPadding: 2, valign: "middle" },
    headStyles: { fillColor: [60, 66, 77], textColor: 255, fontStyle: "bold", fontSize: 8 },
    margin: { top: 30, left: 10, right: 10 },
    pageBreak: "auto",
    rowPageBreak: "avoid",
    didDrawPage: (data) => {
      drawHeader();
      const totalPages = doc.internal.getNumberOfPages();
      drawFooter(doc.internal.getCurrentPageInfo().pageNumber, totalPages);
    }
  });

  // Get Y position after main table
  const finalY = doc.lastAutoTable.finalY || 30;

  const legendHeaders = [["Egg ID", "Egg Type"]];
  const legendRows = eggTypes.map((egg) => [egg.id, egg.name]);
  const estimatedLegendHeight = legendRows.length * 6 + 15;

  // Check if legend fits on current page
  if (finalY + estimatedLegendHeight + 20 < pageHeight) {
    // Draw legend below current table
    doc.autoTable({
      head: legendHeaders,
      body: legendRows,
      theme: "grid",
      styles: { fontSize: 6, cellPadding: 1, halign: "center" },
      headStyles: { fillColor: [100, 100, 100], textColor: 255, fontStyle: "bold", fontSize: 6 },
      tableWidth: 60,
      margin: { left: pageWidth - 70 },
      startY: finalY + 5,
    });
  } else {
    // Move legend to new page
    doc.addPage();
    drawHeader();
    doc.autoTable({
      head: legendHeaders,
      body: legendRows,
      theme: "grid",
      styles: { fontSize: 6, cellPadding: 1, halign: "center" },
      headStyles: { fillColor: [100, 100, 100], textColor: 255, fontStyle: "bold", fontSize: 6 },
      tableWidth: 60,
      margin: { left: pageWidth - 70, top: 30 },
    });
    const totalPages = doc.internal.getNumberOfPages();
    drawFooter(totalPages, totalPages);
  }

  doc.save("daily-entry.pdf");
};
    function handleBulkDailyEntryClose() {
        setMinClosingFeed({})
        setShowBulkAddDialog(false);
    }

    const getAvailableMedicineStock =(data,shedID,dailyEntryID)=>{
        showError('');
        showMessage('');
        const response = api.post(`/medicine-stock/data/${farmID}`, {"date":data,"shedID":shedID,"dailyEntryID":dailyEntryID});
        response.then(res => {
            setAvailableMedcineStock(res);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found'){
                    showError('No Medicine and Vaccination List');
                   setAvailableMedcineStock([])
                }
                else
                    showError(err.message)
            } else {
                showError('Unknown Error')
            }
        });
    
    }

    const onDailyEntryEdit = (dailyEntry) => {
        currentData = {
            ...dailyEntry
        };
        editMode = true;
        setShowDailyEntryDialog(true);
    };

    function onNewDailyEntry(event) {
        editMode = false;
        event.preventDefault();
        setErrorMessage('');
        setShowDailyEntryDialog(true);
    };

    function onNewBulkDailyEntry(event) {
        editMode = false;
        event.preventDefault();
        setErrorMessage('');
        setShowBulkAddDialog(true);
    }

    const onDelete = (data) => {
        currentData = data;
        setShowDeleteConfirm(true);
    };

    function handleDeleteConfirmClose() {
        setShowDeleteConfirm(false);
    }

    const  onDailyEntrySave = (dailyEntry) => {
        var mDailyEntryData = {...dailyEntry,
            eggBreakage: parseInt(dailyEntry.eggBreakage, 10),
            damagedEggs: parseInt(dailyEntry.damagedEggs, 10),
            eggClosingStock: parseInt(dailyEntry.eggClosingStock, 10),
            eggSales: parseInt(dailyEntry.eggSales, 10),
            mortality: parseInt(dailyEntry.mortality, 10),
            closingFeed: parseInt(dailyEntry.closingFeed, 10),
            isAutoSales:user?.Config?.auto_sales
        };


        //future date validation
        const selectedDate = new Date(dailyEntry.entryDate);
        const currentDate = new Date();

        if (selectedDate > currentDate) {
            setErrorMessage('Daily Entry cannot be in future');
            return; 
        }
        setLoading(true);

        if(dailyEntry.bodyWeight){
            mDailyEntryData['bodyWeight'] = +parseFloat(mDailyEntryData['bodyWeight']).toFixed(2);
        }
        if(user.versionID === version.lite && dailyEntry.feedReceived){
            mDailyEntryData['feedReceived'] = +parseFloat(mDailyEntryData['feedReceived']).toFixed(2);
        }
        if(dailyEntry.feedReceivedPurchase){
            mDailyEntryData['feedReceivedPurchase'] = +parseFloat(mDailyEntryData['feedReceivedPurchase']).toFixed(2);
        }
        const response = api.post(`farm/${farmID}/daily-entry`,mDailyEntryData);
        response.then(res => {
            //console.debug("dailyEntry",dailyEntry,res)
            // get all onboardingTasks and update if it is the first daily entry
            updateOnboardingTaskStatus(user, dispatch, "CREATE_DAILY_ENTRY", farmID);
            
            setErrorMessage('')
            setShowDailyEntryDialog(false);

            //check duplicate entry already present
            let index = dailyEntries.findIndex((srcData) => {
                return  srcData.id === res.oldId
            });
            if (index !== -1 ) {
                setDailyEntries([...dailyEntries.slice(0, index),
                { ...res },
                ...dailyEntries.slice(index + 1)]);

            } else {
                setDailyEntries([...dailyEntries, res]);
            }
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setErrorMessage('Daily Entry not added');
                else if (err.message === 'Duplicate Key' || err.message === 'duplicate key')
                setErrorMessage('Data already exists for '+dailyEntry.shedName+' on '+moment(dailyEntry.entryDate).format("DD-MM-YYYY"));
                else
                setErrorMessage(err.message)
            } else {
                showError('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        });
    };

    const onDailyEntryUpdate = (dailyEntry) => {
        //future date validation
        const selectedDate = new Date(dailyEntry.entryDate);
        const currentDate = new Date();

        if (selectedDate > currentDate) {
            setErrorMessage('Daily Entry cannot be in future');
            return; 
        }
       
        setLoading(true);
        // showError('');
        var mDailyEntryData = {...dailyEntry,
            eggBreakage: parseInt(dailyEntry.eggBreakage, 10),
            damagedEggs: parseInt(dailyEntry.damagedEggs, 10),
            eggClosingStock: parseInt(dailyEntry.eggClosingStock, 10),
            eggSales: parseInt(dailyEntry.eggSales, 10),
            mortality: parseInt(dailyEntry.mortality, 10),
            closingFeed: parseInt(dailyEntry.closingFeed, 10),
            doubleEggs:parseInt(dailyEntry.doubleEggs,10),
            dirtyEggs:parseInt(dailyEntry.dirtyEggs,10),
            isAutoSales:user?.Config?.auto_sales
        };
        if(dailyEntry.bodyWeight){
            mDailyEntryData['bodyWeight'] = +parseFloat(mDailyEntryData['bodyWeight']).toFixed(2);
        }
        if(user.versionID === version.lite && dailyEntry.feedReceived){
            mDailyEntryData['feedReceived'] = +parseFloat(mDailyEntryData['feedReceived']).toFixed(2);
        }
        if(dailyEntry.feedReceivedPurchase){
            mDailyEntryData['feedReceivedPurchase'] = +parseFloat(mDailyEntryData['feedReceivedPurchase']).toFixed(2);
        }
        const response = api.post(`farm/${farmID}/daily-entry/${dailyEntry.id}`,mDailyEntryData);
        response.then((res) => {
            let index = dailyEntries.findIndex((srcData) => {
                return srcData.id === res.id;
            });
       
            setDailyEntries([...dailyEntries.slice(0, index),
            { ...res },
            ...dailyEntries.slice(index + 1)]);
            setShowDailyEntryDialog(false);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setErrorMessage('Daily Entry not updated');
                else if (err.message === 'Duplicate Key' || err.message === 'duplicate key')
                    setErrorMessage('Data already exists for '+dailyEntry.shedName+' on '+moment(dailyEntry.entryDate).format("DD-MM-YYYY"));
                else
                    setErrorMessage(err.message)
            } else {
                setErrorMessage('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleDailyEntryOCRData = (builkEntriesData) =>{
        editMode = false;
        setErrorMessage('');
        setBuilkEntriesData(builkEntriesData);
        setShowBulkAddDialog(true);
    }
    function onDeleteConfirm() {
        if (currentData && currentData.id) {
            setShowDeleteConfirm(false);
            setLoading(true);
            showError('');
            const response = api.delete(`farm/${farmID}/daily-entry/${currentData.id}`);

            response.then(res => {
                if (res) {
                    let index = dailyEntries.findIndex((src) => {
                        return src.id === currentData.id;
                    });
                    let newData = [...dailyEntries];
                    newData.splice(index, 1);
                    setDailyEntries(newData);
                }
            }).catch(err => {
                if (err.message) {
                    if (err.message === 'Bad Request' || err.message === 'No data found')
                        showError('Daily Entry not Deleted');
                    else
                        showError(err.message)
                } else {
                    showError('Unknown Error')
                }
            }).finally(() => {
                setLoading(false);
                currentData = undefined;
            });

        }
    }

    //Get all Daily Entry API Call
    const getAll = () => {
        setLoading(true);
        showError('');
        showMessage('');
        const getDailyEntriesResponse = api.get(`farm/${farmID}/daily-entry`).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    showError('No Daily Entry');
                else
                    showError(err.message)
            } else {
                showError('Unknown Error')
            }
        });
        const getMatListsResponse = api.post(`farm/${farmID}/daily-entry-material-list`).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    showError('No Materials Found');
                else
                    showError(err.message)
            } else {
                showError('Unknown Error')
            }
        });
        const getShedsResponse = api.get(`farm/${farmID}/shed`).catch(err => {
            if (err.message) {
                console.log(err.message)
            } else {
                console.log('Unknown Error')
            }
        });
        Promise.all([getDailyEntriesResponse,getMatListsResponse,getShedsResponse]).then(results => {
            if(results[0])
                setDailyEntries(results[0].map(normalizeBroilerEntry));
            if(results[1])
                setMaterialList([...results[1]]);
            if(results[2])
                setSheds([...results[2]]);
        }).finally(() => {
            setLoading(false);
        });
        if (showPurchases) {
            // 404 when no feed material exists yet; the dialog then shows an "Add Feed Type" link
            api.get('feed-rate-materials').then(res => {
                setFeedMaterials(res || []);
            }).catch(() => {
                setFeedMaterials([]);
            });
        }
    }
    
    

    //Get all Daily Entry By Date API Call
    const getAllDailyEntryForDate = () => {

        if (filterSelectedEndDate === null && filterSelectedStartDate === null) {
            getAll()
        }
        if (filterSelectedEndDate !== null && filterSelectedStartDate !== null &&
            filterSelectedEndDate < filterSelectedStartDate) {
            showError('Start Date is Greater than or Equal to End Date');
            return
        }
        let payload = {
            startDate: filterSelectedStartDate,
            endDate: filterSelectedEndDate,
            farmId: parseInt(farmID, 10),
        }

        setLoading(true);
        showError('');
        showMessage('');

        const response = api.post(`farm/${farmID}/daily-entry-by-date`, { ...payload });

        response.then(res => {
            setDailyEntries([...res]);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    showError('No Daily Entry Found');
                else
                    showError(err.message)
            } else {
                showError('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        });
    }
    //Get Min Closing Feed API Call
    const getMinClosingFeed = (shedId, entryDate, shedName) => {
        setLoading(true);
        // showError('');
        showMessage('');

        const response = api.post(`farm/${farmID}/get-minimum-closing-feed`, {
            shedId: shedId,
            farmId: parseInt(farmID, 10),
            entryDate: entryDate,
            shedName : shedName
        });

        response.then(res => {
            console.debug(res)
            setMinClosingFeed(res);
        }).catch(err => {
            if (err.message) {
                console.log(err.message)
            } else {
                console.log('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        });
        console.debug(minClosingFeed)
    }

    const removeErrorMessage = value =>{
        setErrorMessage('');
    }

    const handleFilterStartDateChange = date => {
        setFilterSelectedStartDate(date);
    };

    const handleFilterEndDateChange = date => {
        setFilterSelectedEndDate(date);
    };

    const clearDateRangeFilter = () => {
        setFilterSelectedStartDate(null)
        setFilterSelectedEndDate(null)
        getAll()

    }
    useEffect(getAll, []);
    
    
    useEffect(()=>{
        if (sheds.length > 0) {
            setPageSize(sheds.length);
            const isStandardPageSize = standardPageSizes.includes(sheds.length);
            rowsPerPageArray.current = isStandardPageSize ? standardPageSizes : [...standardPageSizes, sheds.length].sort((a, b) => a - b);
        }
    },[sheds])
    let dailyEntryColumnDefaults = { title: 'Shed Name', field: 'shedName' };
    let dailyEntryColumn = {
        ...dailyEntryColumnDefaults,
        render: rowData => <Mobile data={rowData}
            onEdit={() => { onDailyEntryEdit(rowData) }}
            onDelete={() => { onDelete(rowData) }}
            farmType={farmType}
        />,
        // Other columns are hidden on mobile, and material-table skips hidden columns when searching
        customFilterAndSearch: (term, rowData) => {
            const values = [
                rowData.shedName,
                rowData.batchName,
                moment(rowData.entryDate).format("DD-MM-YYYY"),
            ];
            return values.some(value => value !== undefined && value !== null &&
                String(value).toLowerCase().includes(term.toLowerCase()));
        },
    };
    let actions = [];
    if (isDesktop) {
        dailyEntryColumn = dailyEntryColumnDefaults;
        actions = [
            rowData=>({
                icon: () => {
                    return <Icon color='primary'>edit</Icon> 
                },
                tooltip: (user.role !== "ADMIN" && user.role !== "FARMADMIN" && !isToday(rowData.entryDate)) ? 'Please contact your Administrator to edit old data' : 'Edit Daily Entry',
                onClick: (event, rowData) => {
                    onDailyEntryEdit(rowData);
                },
                disabled:(user.role !== "ADMIN" && user.role !== "FARMADMIN" && !isToday(rowData.entryDate))
            }),
            rowData=>({
                icon: () => <Icon color='error'>delete</Icon>,
                tooltip: (user.role !== "ADMIN" && user.role !== "FARMADMIN" && !isToday(rowData.entryDate)) ? 'Please contact your Administrator to delete old data' :  'Delete Daily Entry',
                onClick: (event, rowData) => {
                    onDelete(rowData);
                },
                disabled:(user.role !== "ADMIN" && user.role !== "FARMADMIN" && !isToday(rowData.entryDate))
            })
        ]
    }
    let dailyEntryAllColumns = [];
    if (farmType === FarmType.BROILER) {
        dailyEntryAllColumns = [
                    {
                        title: 'Date', field: 'entryDate', type: 'datetime', defaultSort: 'desc',
                        editable: 'never',
                        hidden: !isDesktop,
                        render: rowData => {
                            return <span>{moment(rowData.entryDate).format("DD-MM-YYYY")}</span>
                        }
                    },
                    dailyEntryColumn,
                    { title: 'Mortality (Nos)', field: 'mortality', hidden: !isDesktop },
                    { title: 'Closing Feed (Kg)', field: 'closingFeed', hidden: !isDesktop },
                    { title: 'Avg Weight', field: 'bodyWeight', hidden: !isDesktop },
                    { title: 'Water (L)', field: 'water', hidden: !isDesktop },
                    { title: 'Uniformity %', field: 'uniformity', hidden: !isDesktop },
                    { title: 'Observation', field: 'dailyObservation', hidden: !isDesktop },
        ];
    } else {
        dailyEntryAllColumns = [
                    {
                        title: 'Date', field: 'entryDate', type: 'datetime', defaultSort: 'desc',
                        editable: 'never',
                        hidden: !isDesktop,
                        render: rowData => {
                            return <span>{moment(rowData.entryDate).format("DD-MM-YYYY")}</span>
                        }
                    },
                    dailyEntryColumn,
                    { title: 'Egg type', field: 'materialTypeName', hidden: !isDesktop },
                    { title: 'Mortality (Nos)', field: 'mortality', hidden: !isDesktop },
                    { title: 'Egg Sales (Trays)', field: 'eggSales', hidden: !isDesktop },
                    { title: 'Egg Closing (Trays)', field: 'eggClosingStock', hidden: !isDesktop },
                    { title: 'Broken Egg (Nos)', field: 'eggBreakage', hidden: !isDesktop },
                    { title: 'Damaged Eggs (Nos)', field: 'damagedEggs', hidden: !isDesktop },
        ];
        if(user.versionID === version.lite){
            dailyEntryAllColumns.push(
                {title: 'Feed received (Kg)', field: 'feedReceived', hidden: !isDesktop},
                {title: 'Closing Feed (Kg)', field: 'closingFeed', hidden: !isDesktop}
                );
        } else if (showPurchases) {
            dailyEntryAllColumns.push(
                { title: 'Feed type', field: 'feedMaterialName', hidden: !isDesktop },
                { title: 'Feed received (Kg)', field: 'feedReceivedPurchase', hidden: !isDesktop },
                { title: 'Closing Feed (Kg)', field: 'closingFeed', hidden: !isDesktop }
            );
        } else {
            dailyEntryAllColumns.push({
                title: 'Closing Feed (Kg)', field: 'closingFeed', hidden: !isDesktop
            });
        }
    }

    // AI-Powered Image Upload + Manual Entry boxes: page body on desktop, PageHeader dropdown on mobile
    const entryBoxes = <>
                {farmType !== 2 && (
                    <div style={{ ...entryBoxStyle, padding: isDesktop ? '12px 16px' : '8px 10px', ...(isDesktop ? {} : { flex: '1 1 100%' }) }}>
                        <Typography variant="h6" gutterBottom noWrap>
                            AI-Powered Image Upload
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center', gap: isDesktop ? 12 : 6 }}>
                            <ImageToStruct
                                handleImageParseError={handleImageParseError}
                                handleDailyEntryOCRData={handleDailyEntryOCRData}
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                size={isDesktop ? 'medium' : 'small'}
                                style={{ whiteSpace: 'nowrap' }}
                                onClick={generateDailyEntryLandscapePDF}
                            >
                                Download Template
                            </Button>
                        </div>
                    </div>
                )}
                <div style={{ ...entryBoxStyle, padding: isDesktop ? '12px 16px' : '8px 10px', ...(isDesktop ? {} : { flex: '1 1 100%' }) }}>
                    <Typography variant="h6" gutterBottom noWrap>
                        Manual Entry
                    </Typography>
                    <div style={{ display: 'flex', alignItems: 'center', gap: isDesktop ? 12 : 6 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size={isDesktop ? 'medium' : 'small'}
                            style={{ whiteSpace: 'nowrap' }}
                            onClick={onNewDailyEntry}
                        >
                            Add Daily Entry
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            size={isDesktop ? 'medium' : 'small'}
                            style={{ whiteSpace: 'nowrap' }}
                            onClick={onNewBulkDailyEntry}
                        >
                            Add Bulk Daily Entry
                        </Button>
                    </div>
                </div>
    </>;

    return (
        <div className={classes.root}>
            <PageHeader
                title='Daily Entries'
                panelExtra={!isDesktop ? entryBoxes : null}
                filters={
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            margin="none"
                            autoOk
                            variant="inline"
                            inputVariant='outlined'
                            label="From"
                            format="dd/MM/yyyy"
                            size="small"
                            value={filterSelectedStartDate || null}
                            onChange={handleFilterStartDateChange}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                        <KeyboardDatePicker
                            margin="none"
                            autoOk
                            variant="inline"
                            inputVariant='outlined'
                            label="To"
                            format="dd/MM/yyyy"
                            size="small"
                            value={filterSelectedEndDate || null}
                            onChange={handleFilterEndDateChange}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                    </MuiPickersUtilsProvider>
                }
                onSearch={getAllDailyEntryForDate}
                onClearSearch={clearDateRangeFilter}
            />
            <div className={classes.content}>
            {/* Entry boxes: each box keeps its title and its own buttons together (on mobile they're in the PageHeader dropdown) */}
            {isDesktop &&
            <div style={{ display: 'flex', flexWrap: 'nowrap', overflowX: 'auto', gap: isDesktop ? 12 : 8, marginBottom: 8, margin: '0 2rem', marginTop:'1rem' }}>
                {entryBoxes}
            </div>
            }
            <MaterialTable
                spacing={5}
                isLoading={loading}
                columns={dailyEntryAllColumns}
                data={dailyEntries}
                options={{
                    actionsColumnIndex: -1,
                    search: true,
                    showTitle: true,
                    
                    toolbar: true,
                    header: isDesktop,
                    pageSize:pageSize,
                    pageSizeOptions: rowsPerPageArray.current ? rowsPerPageArray.current : standardPageSizes
                }}
                actions={actions}
                title='Daily Entries'
            />
            </div>
            <NewDailyEntry errorMessage={errorMessage} showDialog={showDailyEntryDialog} handleClose={handleDailyEntryClose} onSave={onDailyEntrySave}
                onEdit={onDailyEntryUpdate} sheds={sheds} materialLists={materialLists} minClosingFeed={minClosingFeed}
                editMode={editMode} data={currentData} getMinClosingFeed={getMinClosingFeed} deleteErrorMessage={removeErrorMessage} getAvailbleMedicineList={getAvailableMedicineStock} medicineList={availableMedicineStock}
                feedMaterials={feedMaterials} farmType={farmType} match={match} />
            <ConfirmDialog showDialog={showDeleteConfirm}
                handleClose={handleDeleteConfirmClose}
                onConfirm={onDeleteConfirm}
                title='Delete Daily Entry ?'
                subText='This action will delete the Daily Entry.' />
            <NewBulkDailyEntry showDialog={ShowBulkAddDialog} handleClose={handleBulkDailyEntryClose} match={match} sheds={sheds} 
                materialLists={materialLists} farmID={farmID} getMinClosingFeed={getMinClosingFeed} minClosingFeed={minClosingFeed}
                dailyEntries={dailyEntries} getAllDailyEntryForDate={getAllDailyEntryForDate} showError={showError} deleteErrorMessage={removeErrorMessage} farmType={farmType}
                builkEntriesData={builkEntriesData}
            />
        </div>
    );
};

export default DailyEntries;
